module.exports = __webpack_public_path__ + "static/Home_HeroImage-a901f0bb867eab6fcc2a05ce1a2bb3c3.jpg";